import React, { PureComponent } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Table from "../../../_common/Table";
import AlertModal from "../../../_common/AlertModal";
import EditLaborCrewsModal from "./EditLaborCrewsModal";
import LaborCrewDetails from "./LaborCrewDetails";
import laborCrewActions from "../../../../_actions/laborCrewActions";
import laborActions from "../../../../_actions/laborActions";
import contractorActions from "../../../../_actions/contractorActions";

class LaborCrews extends PureComponent {
  state = {
    selectedLaborCrewId: null,
    showEditLcModal: false,
    isNew: false,
    laborCrewFilter: "",
    sortColumn: { path: "crewName", order: "asc" },
    showDeleteLcAlert: false,
  };

  columns = [
    { path: "crewName", label: "Crew Name" },
    { path: "createdByUserFullName", label: "Created By" },
    {
      path: "crewCount",
      label: "Count",
    },
  ];

  componentDidMount() {
    const { dispatch, projectId } = this.props;

    dispatch(laborActions.getAll(projectId));
    dispatch(laborCrewActions.getAll(projectId));
    dispatch(contractorActions.getAllForProject(projectId));
  }

  handleChange_laborCrewFilter = (e) =>
    this.setState({ laborCrewFilter: e.target.value });

  toggleEditLcModal = () =>
    this.setState({ showEditLcModal: !this.state.showEditLcModal });

  handleSort = (sortColumn) => this.setState({ sortColumn });

  handleClick_clearFilters = (e) => {
    e.preventDefault();
    this.setState({ laborCrewFilter: "" });
  };

  handleClick_lcTr = (selectedLaborCrew) =>
    this.setState({ selectedLaborCrewId: selectedLaborCrew.laborCrewId });

  handleClick_editLaborCrewDetails = (e) => {
    e.preventDefault();
    this.setState({ isNew: false });
    this.toggleEditLcModal();
  };
  handleClick_deleteLaborCrew = () => this.toggleDeleteLcAlert();

  toggleDeleteLcAlert = () =>
    this.setState({ showDeleteLcAlert: !this.state.showDeleteLcAlert });

  handleAlert_deleteLaborCrew = (alertAction) => async (e) => {
    e.preventDefault();
    const { dispatch, projectId } = this.props;
    const { selectedLaborCrewId } = this.state;
    if (alertAction === "accept") {
      // TODO: catch error and show alert
      await dispatch(laborCrewActions.deleteCrew(selectedLaborCrewId, projectId));
      this.setState({ selectedLaborCrewId: null });
    }
    this.toggleDeleteLcAlert();
  };

  getData = () => {
    const { projLaborCrewList } = this.props;
    const { sortColumn, laborCrewFilter } = this.state;
    if (!laborCrewFilter) return projLaborCrewList || [];
    const filteredList = (projLaborCrewList || []).filter((lc) =>
      lc.crewName.toLowerCase().includes(laborCrewFilter.toLowerCase())
    );
    return _.orderBy(filteredList, [sortColumn.path], [sortColumn.order]);
  };

  renderTableFilters = () => {
    const { laborCrewFilter } = this.state;
    return (
      <div className="form-inline mb-2">
        <div className="col-6 px-0">
          <div className="input-group">
            <div className="input-group-prepend">
              <span className="input-group-text bg-lightgray">
                <FontAwesomeIcon icon="search" className="fa-fw text-muted" />
              </span>
            </div>
            <input
              name="laborCrewFilter"
              id="laborCrewFilter"
              className="form-control col-12 mr-2"
              value={laborCrewFilter}
              onChange={this.handleChange_laborCrewFilter}
            />
          </div>
        </div>
        <button
          type="button"
          name="clearLaborCrewFilter"
          id="clearLaborCrewFilter"
          className="btn btn-secondary mx-2"
          onClick={this.handleClick_clearFilters}
        >
          Clear
        </button>
        <button
          type="button"
          name="addNewLaborCrew"
          id="addNewLaborCrew"
          className="btn btn-info px-2"
          onClick={() =>
            this.setState({
              isNew: true,
              selectedLaborCrewId: null,
              showEditLcModal: !this.state.showEditLcModal,
            })
          }
        >
          <FontAwesomeIcon icon="plus" className="fa-fw" />
        </button>
      </div>
    );
  };

  render() {
    const { showEditLcModal, sortColumn, isNew, selectedLaborCrewId, showDeleteLcAlert } =
      this.state;
    const { projectId, projLaborList, projContractorList } = this.props;
    const data = this.getData();
    const laborCrew = data.find((lc) => lc.laborCrewId === selectedLaborCrewId);
    return (
      <React.Fragment>
        <div className="d-flex flex-row w-100 p-2">
          <div className="pa-list">
            {this.renderTableFilters()}
            <div className="pa-list__table--wrapper border">
              <Table
                className="table table-sm table-hover pa-list__table"
                data={data}
                columns={this.columns}
                idPropName={"laborCrewId"}
                selectedItemId={selectedLaborCrewId && selectedLaborCrewId}
                sortColumn={sortColumn}
                onSort={this.handleSort}
                handleClick_tr={this.handleClick_lcTr}
              />
            </div>
          </div>
          <div className="pa-details">
            <div className="card w-100 sticky-top top-margin-30">
              <div className="card-header bg-lightgray">Labor Details</div>
              <div className="card-body p-3">
                <LaborCrewDetails
                  laborCrew={laborCrew}
                  projLaborList={projLaborList}
                  handleClick_editLaborCrewDetails={this.handleClick_editLaborCrewDetails}
                  handleClick_deleteLaborCrew={this.handleClick_deleteLaborCrew}
                />
              </div>
            </div>
          </div>
        </div>
        {showEditLcModal && (
          <EditLaborCrewsModal
            showEditLcModal={showEditLcModal}
            toggleEditLcModal={this.toggleEditLcModal}
            isNew={isNew}
            laborCrew={data.find((lc) => lc.laborCrewId === selectedLaborCrewId)}
            projectId={projectId}
            projLaborList={projLaborList}
            projContractorList={projContractorList}
            lcList={data}
          />
        )}
        {showDeleteLcAlert && (
          <AlertModal
            alertTitle="Delete Labor Crew"
            alertTitleClass="bg-warning"
            alertTitleIcon="exclamation-triangle"
            alertText={`Are you sure you want to delete this crew?`}
            acceptCaption="Yes"
            acceptClass="danger"
            provideReject={true}
            rejectCaption="No"
            rejectClass="secondary"
            toggleAlertModal={this.toggleDeleteLcAlert}
            handleAlertAction={this.handleAlert_deleteLaborCrew}
            showAlertModal={showDeleteLcAlert}
          />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  projLaborList: state.labors.projLaborLists[ownProps.projectId] || null,
  projLaborCrewList: state.laborCrews.projLaborCrewLists[ownProps.projectId] || null,
  projContractorList: state.contractors.projContractorLists[ownProps.projectId] || null,
});

export default connect(mapStateToProps)(LaborCrews);
